(function () {
  function initKq6Ideal(root) {
    if (!root || root.dataset.kq6IdealInitialized === 'true') return;

    root.dataset.kq6IdealInitialized = 'true';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-kq6-ideal-trigger]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-kq6-ideal-panel]'));
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!triggers.length || !panels.length) return;

    function setActive(index) {
      if (index === null || index === undefined) return;

      root.setAttribute('data-kq6-ideal-active', index);

      triggers.forEach(function (trigger) {
        var isActive = trigger.getAttribute('data-kq6-ideal-trigger') === String(index);

        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-kq6-ideal-panel') === String(index);

        panel.classList.toggle('is-active', isActive);
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        setActive(trigger.getAttribute('data-kq6-ideal-trigger'));
      });

      trigger.addEventListener('mouseenter', function () {
        if (!canHover) return;
        setActive(trigger.getAttribute('data-kq6-ideal-trigger'));
      });

      trigger.addEventListener('focus', function () {
        if (!canHover) return;
        setActive(trigger.getAttribute('data-kq6-ideal-trigger'));
      });
    });

    setActive(root.getAttribute('data-kq6-ideal-active') || '0');
  }

  function initAllKq6Ideal() {
    var roots = document.querySelectorAll('.js-kq6-ideal');

    roots.forEach(function (root) {
      initKq6Ideal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllKq6Ideal);
  } else {
    initAllKq6Ideal();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.js-kq6-ideal');

    if (root) {
      root.dataset.kq6IdealInitialized = 'false';
      initKq6Ideal(root);
    }
  });
})();